module.exports = __webpack_public_path__ + "img/ImmediateClaim.658b0e28.png";